// extracted by mini-css-extract-plugin
export default {"container":"IpvPP","chart":"SWYUa","title":"BpFyr"};